import { render, staticRenderFns } from "./RoleDialog.vue?vue&type=template&id=6a5ffb44&scoped=true&"
import script from "./RoleDialog.vue?vue&type=script&lang=js&"
export * from "./RoleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5ffb44",
  null
  
)

export default component.exports